var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"btn_next",attrs:{"icon":""}},'v-btn',{ ..._vm.$attrs },false),_vm.$listeners),[_c('v-img',{attrs:{"alt":"logo","src":require("@/assets/images/btn_next.svg")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }